import React from 'react';
import '../SuggestedOrganizations.css';
import { handleAlert } from '../../../../utils/handleAlert';
import JoinIconWhite from '../../../../assets/LandingPage/Org/joinOrgWhiteIcon.svg';
import { organizationAPI } from '../../../../api/requests/organization/organizationAPI';
import { Button } from '@mui/material';
import { RoundedButton } from '../../../Form';

export default function RequestToJoin({ disabled, OrganizationID }) {
  const handleJoinRequest = async (OrganizationID) => {
    try {
      await organizationAPI.requestToJoinOrganization(OrganizationID);
      handleAlert('Join request sent successfully', 'success');
    } catch (error) {
      console.error('Error sending join request:', error);     
      if (error?.message === 'USER_ORG_MAP_EXIST') {
        handleAlert('You are already a member of this organization', 'error');
      } else {
        handleAlert('Failed to send join request. Please try again.', 'error');
      }
    }
  };
  return (
    <RoundedButton
      onClick={() => handleJoinRequest(OrganizationID)}
      disabled={disabled}
      variant='contained'
    >
      Request to Join
      <img src={JoinIconWhite} alt="" style={{marginLeft:'8px'}} />
    </RoundedButton>
  );
}
